import { Directive, effect, inject, input, Type, ViewContainerRef } from '@angular/core';

import { CustomPageComponentsMap } from '../models';
import { CustomPageBlockComponent } from './custom-page-block.component';
import { CustomPageContentComponent } from './custom-page-content.component';
import { CustomPageHeadingComponent } from './custom-page-heading.component';
import { CustomPageImageComponent } from './custom-page-image.component';
import { CustomPageRepeatableBlockComponent } from './custom-page-repeatable-block.component';
import { CustomPageUnorderedListComponent } from './custom-page-unordered-list.component';
import { CustomPageUrlButtonComponent } from './custom-page-url-button.component';
import { CustomPageVideoComponent } from './custom-page-video.component';
import { CustomPageYouTubeVideoComponent } from './custom-page-youtube-video.component';
import { CustomPageGoogleFormComponent } from './custom-page-google-form.component';

const components: { [T in keyof CustomPageComponentsMap]: Type<CustomPageBlockComponent<T>> } = {
  heading: CustomPageHeadingComponent,
  content: CustomPageContentComponent,
  image: CustomPageImageComponent,
  video: CustomPageVideoComponent,
  url_button: CustomPageUrlButtonComponent,
  unordered_list: CustomPageUnorderedListComponent,
  youtube_video: CustomPageYouTubeVideoComponent,
  repeatable_block: CustomPageRepeatableBlockComponent,
  google_form_block: CustomPageGoogleFormComponent,
};

@Directive({
  selector: '[appContentBlock]',
  standalone: true,
})
export class ContentBlockDirective<T extends keyof CustomPageComponentsMap> {
  type = input.required<T>();
  data = input.required<CustomPageComponentsMap[T]>();

  protected vcr = inject(ViewContainerRef);

  constructor() {
    effect(() => {
      if (this.vcr.length) {
        this.vcr.clear();
      }

      const component = components[this.type()];
      const ref = this.vcr.createComponent(component);
      ref.instance.data = this.data;
    });
  }
}
